import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { PaymentModeMasterPopup } from './PaymentModeMasterTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class PaymentModeMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            paymentObject: {
                idPaymentMode: 0,
                updateStatus: 0,
                paymentMode: "",
                remarks: "",
                eDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                paymentMode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "size name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterPaymentModeSelectbyID(event.data.idPaymentMode);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.paymentObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.paymentObject;
        details[name] = value;
        this.setState({ paymentObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let paymentObject = this.state.paymentObject;
        paymentObject.idPaymentMode = 0;
        paymentObject.updateStatus = 0;
        paymentObject.paymentMode = "";
        paymentObject.remarks = "";
        paymentObject.eDate = "";
        this.setState({
            paymentObject: paymentObject, validState: validState
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                // this.getMasterExpenseAccGroupCount();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Payment Mode Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idPaymentMode"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Payment Mode Master",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.06,
            "paymentMode": window.innerWidth * 0.5,
            "remarks": window.innerWidth * 0.2,
        }
        return colwidth[key]
    }


    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.paymentObject;
            let requestData = {
                idPaymentMode: details.idPaymentMode,
                paymentMode: details.paymentMode,
                remarks: details.remarks,
                idCompany: this.state.idCompany,
                e_Date: details.eDate && details.eDate !== 'Invalid date' ? details.eDate : new Date().toISOString(),
                isDeleted: false,
                deletedDate: null,
            };
            this.masterEntryServices.submitPaymentModeMaster(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (dynamicData.errorType === 'Exists') {
                                this.SwalServices.Warning(dynamicData.errorMessage);
                            } else {
                                if (this.state.paymentObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getMasterPaymentModeSelectbyID = (id) => {
        this.masterEntryServices.getMasterPaymentModeSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                let data = this.state.paymentObject;
                data.idPaymentMode = res.idPaymentMode;
                data.updateStatus = 1;
                data.paymentMode = res.paymentMode;
                data.remarks = res.remarks;
                data.eDate = res.e_Date;
                //data.isDeleted = false;
                //data.deletedDate = res.;
                this.setState({
                    paymentObject: data,
                    isModalOpen: true
                });
            }
        });
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <PaymentModeMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            paymentObject={this.state.paymentObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Payment mode master</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
